module.exports = __webpack_public_path__ + "img/da.161d6403.svg";